import { render, staticRenderFns } from "./DebugInfoSection.vue?vue&type=template&id=763fcd28&scoped=true"
import script from "./DebugInfoSection.vue?vue&type=script&lang=ts"
export * from "./DebugInfoSection.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=763fcd28&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763fcd28",
  null
  
)

export default component.exports